import { useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef } from 'react'

import { FaxDetectNodeData } from '../../../converters/shared/reactFlowTypes'

/**
 * Hook for fax detect node functionality.
 * Handles fax extension ID updates.
 */
export const useFaxDetectNode = (id: string, data: FaxDetectNodeData) => {
  const { updateNodeData } = useReactFlow()
  const dataRef = useRef(data)

  // Keep dataRef in sync with data
  useEffect(() => {
    dataRef.current = data
  }, [data])

  // Support both faxExtensionId (new) and faxDestination (legacy)
  const currentFaxExtensionId =
    data.faxExtensionId || data.faxDestination
      ? String(data.faxExtensionId || data.faxDestination)
      : ''

  const handleFaxExtensionChange = useCallback(
    (faxExtensionId: string | undefined) => {
      updateNodeData(id, {
        ...dataRef.current,
        faxExtensionId,
        // Clear legacy field if setting new one
        ...(faxExtensionId ? { faxDestination: undefined } : {}),
      })
    },
    [id, updateNodeData],
  )

  return {
    currentFaxExtensionId,
    handleFaxExtensionChange,
    hasData: !!currentFaxExtensionId,
  }
}
